import { Badge, type BadgeProps } from '@/components/base/badge'
import { steppableColors } from '@/constants'

const kinds: { [state: string]: { color: BadgeProps['color'], name: string } } = {
  CapacitanceTestStepType: {
    color: steppableColors['CapacitanceTestStepType'],
    name: 'Capacitance',
  },
  DiodeTestStepType: {
    color: steppableColors['DiodeTestStepType'],
    name: 'Diode',
  },
  HipotTestStepType: {
    color: steppableColors['HipotTestStepType'],
    name: 'Hipot',
  },
  LinkTestStepType: {
    color: steppableColors['LinkTestStepType'],
    name: 'Link',
  },
  LoadTestStepType: {
    color: steppableColors['LoadTestStepType'],
    name: 'Load',
  },
  NoopTestStepType: {
    color: steppableColors['NoopTestStepType'],
    name: 'Noop',
  },
  RcdTestStepType: {
    color: steppableColors['RcdTestStepType'],
    name: 'RCD',
  },
  ResistanceTestStepType: {
    color: steppableColors['ResistanceTestStepType'],
    name: 'Resistance',
  },
  ResistanceFourWireTestStepType: {
    color: steppableColors['ResistanceFourWireTestStepType'],
    name: 'Resistance 4W',
  },
  TwistedPairTestStepType: {
    color: steppableColors['TwistedPairTestStepType'],
    name: 'Twisted pair',
  },
  WireTestStepType: {
    color: steppableColors['WireTestStepType'],
    name: 'Wire',
  },
  WireFourWireTestStepType: {
    color: steppableColors['WireFourWireTestStepType'],
    name: 'Wire 4W',
  },
}

interface Props {
  kind: keyof typeof steppableColors
}

export const SteppableKindBadge = ({ kind }: Props) => {
  return <Badge color={ kinds[kind].color }>{ kinds[kind].name }</Badge>
}
